import { forwardRef } from "react";
import ChevronIcon from "../../assets/icons/ChevronIcon";
import './Dropdown.scss';

// This dropdown toggle can be added as a replacement to Bootstrap's Dropdown.Toggle, with the __dropdown class:
//  <Dropdown className='__dropdown'>
//    <Dropdown.Toggle as={DropdownToggle}>
//  </Dropdown.Toggle>

export const DropdownToggle = forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props}>
    <div className='toggle-overflow'>
      <div className="toggle-content">{ children }</div>
      <ChevronIcon className="chevron" />
    </div>
  </button>
));
